import Axios from "@/plugins/Axios";

export class CategoriaCircuito {
  async index() {
    const response = await Axios().get("categoriasCircuitos");
    return response.data;
  }
}
export default new CategoriaCircuito();
